import { getFileExtension } from "@/src/components/Sender/sender.fileAttachmentRules";

/** Max attachments per portfolio upload session (image or PDF). */
export const PORTFOLIO_MAX_ATTACHMENTS = 5;

/** @deprecated Use PORTFOLIO_MAX_ATTACHMENTS */
export const PORTFOLIO_MAX_IMAGES = PORTFOLIO_MAX_ATTACHMENTS;

/** PDF single-file size cap for portfolio upload (MB). */
export const PORTFOLIO_MAX_PDF_SIZE_MB = 20;

/** Hidden file input + iOS prepareFileInput accept for portfolio PDF picks */
export const PORTFOLIO_PDF_ACCEPT = "application/pdf,.pdf";

const MB_IN_BYTES = 1024 * 1024;

const PDF_MIME_TYPES = new Set(["application/pdf", "application/x-pdf"]);

export function isPortfolioPdfFile(file: File): boolean {
  if (getFileExtension(file.name) === "pdf") {
    return true;
  }
  const mime = (file.type || "").toLowerCase();
  return PDF_MIME_TYPES.has(mime);
}

export function isPortfolioPdfOversized(file: File): boolean {
  return file.size > PORTFOLIO_MAX_PDF_SIZE_MB * MB_IN_BYTES;
}

export function arePortfolioUploadAuthHeadersReady(
  authHeaders: Record<string, string>,
): boolean {
  return Object.keys(authHeaders).length > 0;
}
